import Vue from 'vue'
import Vuex from 'vuex'
import checkout from './modules/checkout'
import account from './modules/account'
import trucks from './modules/trucks'
import notification from './modules/notification'
import locale from './modules/locale'
import products from './modules/products'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    checkout,
    account,
    trucks,
    notification,
    locale,
    products
  }
})
